import React from "react";
import { useAgencyQuery } from "views/setting/hooks/useAgencyQueries";
import * as style from "../SettingDefaultOrderDirectView.styles";
import { SkeletonText } from "components/ui/Skeleton";
import { MobileOrderFg } from "types";

interface ConnectDlvAlertViewProps {
  rootStore: any;
}

const ConnectDlvAlertView: React.FC<ConnectDlvAlertViewProps> = ({ rootStore }) => {
  const { data: agencyList, isLoading } = useAgencyQuery({
    rootStore,
    shopCd: rootStore.searchStore.getShopCd,
    token: rootStore.searchStore.getToken,
  });

  const visibleMappedAgencies = agencyList?.data?.filter(
    item => item.isMapping && item.mobileOrderFg !== MobileOrderFg.MUKKEBI, // 먹깨비 제외
  );
  const hasMappedAgency = (visibleMappedAgencies?.length ?? 0) > 0;
  const mappedAgencyNames = visibleMappedAgencies?.map(item => item.channelName).join(", ");
    

  const renderContent = () => {
    if (isLoading) {
      return <SkeletonText lines={2} height="16px" width="250px" spacing="8px" />;
    }

    if (hasMappedAgency) {
      return (
        <>
          <style.Text size="16px" color="#101828" weight="400">
            아래 배달앱에서 주문을 받을때 적용됩니다.
          </style.Text>
          <style.Text size="16px" color="#047BBC" weight="700">
            → {mappedAgencyNames}
          </style.Text>
        </>
      );
    }

    return (
      <>
        <style.Text size="16px" color="#101828" weight="700">
          배달매니저에서 주문 접수 연동하는 채널이 없습니다
        </style.Text>
        <style.Text size="16px" color="#101828" weight="400">
          [배달앱 연동 설정] 탭에서 이용하시는 채널을 연동해보세요!{" "}
        </style.Text>
      </>
    );
  };

  return (
    <style.alertContainer>
      <style.alertDivider />
      {renderContent()}
    </style.alertContainer>
  );
};

export default ConnectDlvAlertView;
